export const applicationSearchSortValues = [
  {
    'value': 'default',
    'display': 'Relevance'
  },
  {
    'value': '^root_appType',
    'display': 'Application Type, Ascending',
    'displayedColumns': 'appType',
    'direction': 'asc'
  },
  {
    'value': '$root_appType',
    'display': 'Application Type, Descending',
    'displayedColumns': 'appType',
    'direction': 'desc'
  },
  {
    'value': '^root_appNumber',
    'display': 'Application Number, Ascending',
    'displayedColumns': 'appNumber',
    'direction': 'asc'
  },
  {
    'value': '$root_appNumber',
    'display': 'Application Number, Descending',
    'displayedColumns': 'appNumber',
    'direction': 'desc'
  },
  {
    'value': '^root_center',
    'display': 'Center, A-Z',
    'displayedColumns': 'center',
    'direction': 'asc'
  },
  {
    'value': '$root_center',
    'display': 'Center, Z-A',
    'displayedColumns': 'center',
    'direction': 'desc'
  },
  {
    'value': '^root_provenace',
    'display': 'Provenance, A-Z',
    'displayedColumns': 'provenance',
    'direction': 'asc'
  },
  {
    'value': '$root_provenance',
    'display': 'Provenance, Z-A',
    'displayedColumns': 'provenance',
    'direction': 'desc'
  },
  {
    'value': '^root_status',
    'display': 'Status, A-Z',
    'displayedColumns': 'applicationStatus',
    'direction': 'asc'
  },
  {
    'value': '$root_status',
    'display': 'Status, Z-A',
    'displayedColumns': 'applicationStatus',
    'direction': 'desc'
  },
  {
    'value': '^root_appStatus',
    'display': 'Status, A-Z',
    'displayedColumns': 'appStatus',
    'direction': 'asc'
  },
  {
    'value': '$root_appStatus',
    'display': 'Status, Z-A',
    'displayedColumns': 'appStatus',
    'direction': 'desc'
  },
  {
    'value': '^root_sponsorName',
    'display': 'Sponsor Name, A-Z',
    'displayedColumns': 'sponsorName',
    'direction': 'asc'
  },
  {
    'value': '$root_sponsorName',
    'display': 'Sponsor Name, Z-A',
    'displayedColumns': 'sponsorName',
    'direction': 'desc'
  },
  {
    'value': '^root_appSubType',
    'display': 'Application Sub Type, A-Z',
    'displayedColumns': 'applicationSubType',
    'direction': 'asc'
  },
  {
    'value': '$root_appSubType',
    'display': 'Application Sub Type, Z-A',
    'displayedColumns': 'applicationSubType',
    'direction': 'desc'
  },
  {
    'value': '^root_applicationProductList_applicationProductNameList_productName',
    'display': 'Product Name, A-Z',
    'displayedColumns': 'productName',
    'direction': 'asc'
  },
  {
    'value': '$root_applicationProductList_applicationProductNameList_productName',
    'display': 'Product Name, Z-A',
    'displayedColumns': 'productName',
    'direction': 'desc'
  },
  {
    'value': '^root_Ingredient Name',
    'display': 'Ingredient Name, A-Z',
    'displayedColumns': 'ingredientName',
    'direction': 'asc'
  },
  {
    'value': '$root_Ingredient Name',
    'display': 'Ingredient Name, Z-A',
    'displayedColumns': 'ingredientName',
    'direction': 'desc'
  },
  {
    'value': '^root_creationDate',
    'display': 'Oldest Creation'
  },
  {
    'value': '$root_creationDate',
    'display': 'Newest Creation'
  },
  {
    'value': '^root_lastModifiedDate',
    'display': 'Oldest Change'
  },
  {
    'value': '$root_lastModifiedDate',
    'display': 'Newest Change'
  }

];
